module.exports = __webpack_public_path__ + "static/media/6_mobile.266f9809.gif";